import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import Root from './Root';

const container = document.getElementById('app');
if (!container) throw new Error('[main] Failed to find #app root element.');

createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<Root />);
